/**
 * Sub1 Template
 * @category testApp
 */
class ServerfilterTempl{
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     */
    static getServerFilterTempl(_d={}) {
        const options = _d.map(ServerfilterTempl.getServerOptionTempl).join('');
        return `
        ${options}
        `;
    }

    static getServerOptionTempl(_d){
        return `
            <option value="${_d.id}" data-server-type="${_d.serverType}">${_d.name}</option>
        `;
    }

} // end of class

export default ServerfilterTempl;